"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M16 17.9c0 1.933-3.6 2.1-6 2.1s-6-.167-6-2.1S5.8 13 10 13s6 2.967 6 4.9m-1.743-7.662c-.294-.078-.384-.426-.245-.698A4.5 4.5 0 0 0 14.5 7.5a4.5 4.5 0 0 0-.558-2.173c-.148-.266-.07-.618.222-.705Q14.563 4.5 15 4.5a2.917 2.917 0 1 1-.744 5.738"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.455 17.705c-.27.036-.509-.162-.563-.429a6.58 6.58 0 0 0-3.058-4.293c-.392-.232-.38-.82.07-.895A7 7 0 0 1 15.001 12c3.5 0 5 2.473 5 4.083 0 1.009-1.176 1.44-2.546 1.622"
  })]
}), 'NewUserFilled');
//# sourceMappingURL=index.js.map